<template>
  <div id="add-dashboard-modal" ref="addDashboardModal" class="uk-modal-container" uk-modal>
    <div class="uk-modal-dialog uk-modal-body">
      <h4 class="uk-modal-title">
        {{ $t('general.add_new_menu') }}
      </h4>

      <div class="row mt-3">
        <div class="col-md-12 mb-3">
          <label class="col-form-label">
            {{ $t('general.target') }}
          </label>
          <select v-model="form.widgetable" class="form-control">
            <option v-for="option in widgetableOptions" :key="option.value" :value="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <div v-for="lang in langOptions" :key="lang.code" class="col-md-6 mb-3">
          <label class="col-form-label">
            {{ lang.name }} ({{ lang.code }})
          </label>
          <input v-model="form.lang_title[lang.code]"
              class="form-control"
              type="text"
          />
        </div>
      </div>

      <p class="uk-text-right mt-4">
        <button class="btn btn-light mr-2 uk-modal-close" type="button" @click="close">
          {{ $t("general.close") }}
        </button>
        <button class="btn btn-default" type="button" @click="submit">
          {{ $t("general.save") }}
        </button>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddDashboardModal",
  props: {
    langOptions: {
      type: Array,
      default: () => []
    },
    widgetableOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: {
        title: '',
        lang_title: {},
        widgetable: 'assignment'
      }
    };
  },
  computed: {
    firstLangCode() {
      return this.langOptions.length ? this.langOptions[0].code : null;
    },
    firstLangValue() {
      if (!this.firstLangCode) return '';
      return this.form.lang_title[this.firstLangCode] || '';
    }
  },
  watch: {
    firstLangValue(val) {
      this.form.title = (val || '').trim().replace(/\s+/g, '-');
    }
  },
  methods: {
    open() {
      const langTitle = {};
      this.langOptions.forEach(lang => {
        langTitle[lang.code] = '';
      });

      const defaultWidgetable = this.widgetableOptions.length ? this.widgetableOptions[0].value : 'assignment';

      this.form = {
        title: '',
        lang_title: langTitle,
        widgetable: defaultWidgetable
      };

      this.$nextTick(() => {
        const modal = UIkit.modal("#add-dashboard-modal");
        if (modal) {
          modal.show();
        }
      });
    },
    close() {
      const modal = UIkit.modal("#add-dashboard-modal");
      if (modal) {
        modal.hide();
      }
    },
    submit() {
      this.$emit('submit', { ...this.form });
    }
  }
};
</script>

<style>
#add-dashboard-modal .uk-modal-dialog {
  max-width: 680px !important;
}
</style>
